export type ErrorRelatedSources = {
  additionalInformation?: string | undefined;
  relatedIssue?: number | undefined;
  relatedPR?: number | undefined;
};
